import { Controller } from "@hotwired/stimulus"

// Applies a cookbook's chosen font pairing to its page by setting the
// --font-display / --font-sans CSS variables on this element (children inherit)
// via the CSSOM — CSP-safe, unlike an inline style= attribute. Absent values
// leave the inherited user/default fonts in place.
export default class extends Controller {
  static values = { title: String, body: String }

  connect() {
    if (this.hasTitleValue && this.titleValue) {
      this.element.style.setProperty("--font-display", `"${this.titleValue}", "DM Sans", sans-serif`)
    }
    if (this.hasBodyValue && this.bodyValue) {
      this.element.style.setProperty("--font-sans", `"${this.bodyValue}", "DM Sans", sans-serif`)
    }
  }
}
